module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/30a425e0a95db6048c84483c5cced06d.png";